import type { ChatMessage, JsonValue } from "../types";
import { BaseComponent } from "./base";
import { Message } from "./message";

export class MessageList extends BaseComponent {
  private showTimestamps: boolean;
  private onApprove?: (toolId: string, toolName: string, args: Record<string, JsonValue>) => void;
  private onReject?: (toolId: string, toolName: string) => void;

  constructor(
    showTimestamps = false,
    onApprove?: (toolId: string, toolName: string, args: Record<string, JsonValue>) => void,
    onReject?: (toolId: string, toolName: string) => void,
  ) {
    super();
    this.showTimestamps = showTimestamps;
    this.onApprove = onApprove;
    this.onReject = onReject;
    this.element = this.create();
  }

  protected create(): HTMLElement {
    const el = document.createElement("div");
    el.className = "ac-messages";
    el.setAttribute("role", "log");
    el.setAttribute("aria-live", "polite");
    el.setAttribute("aria-label", "Conversation");
    return el;
  }

  public addMessage(message: ChatMessage): void {
    const msg = new Message(message, this.showTimestamps, this.onApprove, this.onReject);
    this.element.appendChild(msg.getElement());
    this.scrollToBottom();
  }

  public addTyping(id: string): void {
    const item = document.createElement("div");
    item.className = "ac-msg-wrap ac-msg-assistant ac-typing-wrap";
    item.dataset.typingId = id;
    item.setAttribute("aria-label", "Assistant is typing");
    item.innerHTML = `
      <div class="ac-typing-indicator">
        <span class="ac-dot"></span>
        <span class="ac-dot"></span>
        <span class="ac-dot"></span>
      </div>`;
    this.element.appendChild(item);
    this.scrollToBottom();
  }

  public removeTyping(id: string): void {
    const item = this.element.querySelector(`[data-typing-id="${id}"]`);
    item?.remove();
  }

  public clear(): void {
    this.element.innerHTML = "";
  }

  private scrollToBottom(): void {
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight;
    });
  }
}
